import CardMedia from './CardMedia';

export default CardMedia;
